<template>
    <el-dialog
        :title="title"
        :visible="true"
        :destroy-on-close="true"
        width="600px"
        :close-on-click-modal="false"
        append-to-body
        @close="cancelClick"
    >
        <Form :items="items" :rules="rules" :formData="formData" @close="cancelClick" @submit="confirmClick" ref="form" labelWidth="120px"></Form>
    </el-dialog>
</template>

<script>
import Form from "@/views/zhiji/components/form/Form";

export default {
    name: "AddModal",
    props: ["data"],
    components: {
        Form
    },
    data() {
        return {
            items: [
                {
                    name: "className",
                    label: this.$t("zhiji.personnel.roleManage.permissionName"),
                    type: "el-input",
                    extendProps: {
                        placeholder: this.$t("zhiji.personnel.roleManage.createNameHold"),
                        disabled: this.data.type === "view"
                    }
                },
                {
                    name: "id",
                    label: this.$t("zhiji.personnel.roleManage.permissionId"),
                    type: "el-input",
                    extendProps: {
                        placeholder: this.$t("zhiji.personnel.roleManage.createIdHold"),
                        disabled: this.data.type === "view"
                    }
                }
            ],
            formData: {
                className: this.data.type === "view" ? this.data.node.label : "",
                id: this.data.type === "view" ? this.data.node.id : ""
            },
            rules: {
                className: [{ required: true, message: this.$t("zhiji.personnel.roleManage.createNameHold"), trigger: "blur" }],
                id: [{ required: true, message: this.$t("zhiji.personnel.roleManage.createIdHold"), trigger: "blur" }]
            }
        };
    },
    computed: {
        showDelNameIcon() {
            return this.className != "" && this.data.type !== "view";
        },
        showDelIdIcon() {
            return this.id != "" && this.data.type !== "view";
        },
        title() {
            const arr = ["first", "second", "third", "fourth"];
            const level = arr[this.data.node.level];
            const type =
                this.data.type === "view" ? this.$t(`zhiji.personnel.roleManage.class.view`) : this.$t(`zhiji.personnel.roleManage.class.create`);
            return type + this.$t(`zhiji.personnel.roleManage.class.${level}`);
        }
    },
    methods: {
        cancelClick() {
            this.data.cancel && this.data.cancel.call(null);
        },
        confirmClick(formData) {
            this.$refs.form.validate(async isValid => {
                if (!isValid) {
                    return;
                }
                this.data.confirm &&
                    this.data.confirm.call(null, {
                        name: formData.className,
                        id: formData.id
                    });
                this.close();
            });
        },
        close() {
            this.$emit("closeModal");
        }
    }
};
</script>

<style lang="less" scoped></style>
